export {
    default as image
} from "./image";
